import type { GameEvent, GameState } from "@/types/game";

// 把事件追加到 state.log（不可变更新）
export function pushEvent(state: GameState, evt: GameEvent): GameState {
  return { ...state, log: [...state.log, evt] };
}

export function pushEvents(state: GameState, evts: GameEvent[]): GameState {
  return { ...state, log: [...state.log, ...evts] };
}
